module.exports = __webpack_public_path__ + "img/widget_002.41ddcb27.png";